import React, { Component } from "react";

class SearchBox extends Component {
  state = { q: this.props.initialValue || "" };

  render() {
    return (
      <form
        className="searchbox"
        onSubmit={(e) => {
          e.preventDefault();
          this.onSubmit(this.state.q);
        }}
      >
        <input
          placeholder={this.props.placeholder || "Search.."}
          value={this.state.q}
          onChange={(e) => this.handleChange(e.target.value)}
        />
      </form>
    );
  }

  timer = null;
  onSubmit(q) {
    try {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.props.onChange) this.props.onChange(q);
      }, 200);
    } catch (e) {
      console.warn(e);
    }
  }

  handleChange(q) {
    this.setState({ q });
    if (!this.props.onSubmitOnly || !q) this.onSubmit(q);
  }
}

export default SearchBox;
